import { render, staticRenderFns } from "./draft.vue?vue&type=template&id=5a641c9d&scoped=true"
import script from "./draft.vue?vue&type=script&lang=js"
export * from "./draft.vue?vue&type=script&lang=js"
import style0 from "./draft.vue?vue&type=style&index=0&id=5a641c9d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a641c9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a641c9d')) {
      api.createRecord('5a641c9d', component.options)
    } else {
      api.reload('5a641c9d', component.options)
    }
    module.hot.accept("./draft.vue?vue&type=template&id=5a641c9d&scoped=true", function () {
      api.rerender('5a641c9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sales/salesReps/draft.vue"
export default component.exports